/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TuberculosisHistoryDtoPreviousBloodTestResult =
  | (typeof TuberculosisHistoryDtoPreviousBloodTestResult)[keyof typeof TuberculosisHistoryDtoPreviousBloodTestResult]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TuberculosisHistoryDtoPreviousBloodTestResult = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  INDETERMINATE: 'INDETERMINATE',
  UNKNOWN: 'UNKNOWN',
} as const;
